export default __webpack_public_path__ + "static/media/add_column.7b36aca8.svg";